import { useEffect, useRef, useCallback } from 'react';
import gtag from '@/lib/analytics/gtag';

const EXTE_TAG_ID = import.meta.env['VITE_EXTE_TAG_ID'];
const GTAG_SCRIPT_ID = 'exte-gtag';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

function randomIdentifier(length = 10): string {
  let id = '';

  while (id.length < length) {
    const chunk = window.crypto.randomUUID().replace(/-/g, '');
    id += chunk;
  }

  return id.slice(0, length);
}

export default function useEXTE() {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !EXTE_TAG_ID) return;

    // https://developers.google.com/tag-platform/gtagjs#add_the_google_tag_to_your_website
    if (!document.getElementById(GTAG_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = GTAG_SCRIPT_ID;
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${EXTE_TAG_ID}`;
      document.head.insertBefore(script, document.head.firstChild);
    }

    if (!initializedRef.current) {
      gtag('js', new Date());
      gtag('config', EXTE_TAG_ID);
      initializedRef.current = true;
    }
  }, []);

  const trackEvent = useCallback((event: string) => {
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      send_to: `${EXTE_TAG_ID}/rugie0/${event}+standard`,
    });

    const img = document.createElement('img');
    img.src = `https://ad.doubleclick.net/ddm/activity/src=15139107;type=rugie0;cat=${event};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=1;gdpr_consent=${randomIdentifier()};ord=1?`;
    img.width = 1;
    img.height = 1;
    img.alt = '';

    const noscript = document.createElement('noscript');
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);

  return { trackEvent };
}
